/**
 * Azure AD SSO authentication via Office.js.
 * @module office/auth
 */

/* global Office, __SSO_ENABLED__ */

const SSO_ENABLED = (typeof __SSO_ENABLED__ !== "undefined") ? __SSO_ENABLED__ : false;

let ssoToken = null;

/**
 * Returns the current SSO token, or null if not authenticated via SSO.
 * @returns {string|null}
 */
export function getSsoToken() {
  return ssoToken;
}

/**
 * Attempts to acquire an Azure AD access token via Office SSO.
 * Returns null if SSO is disabled or unavailable.
 * @returns {Promise<string|null>}
 */
export async function getAuthToken() {
  if (!SSO_ENABLED) return null;
  try {
    ssoToken = await Office.auth.getAccessToken({ allowSignInPrompt: true, allowConsentPrompt: true });
    return ssoToken;
  } catch (err) {
    console.warn("SSO indisponible, fallback email manuel :", err.code || err.message, "| Détails :", JSON.stringify({ code: err.code, message: err.message, name: err.name }));
    ssoToken = null;
    return null;
  }
}
